
import { call, put, takeEvery } from 'redux-saga/effects';
import * as _ from 'underscore';

import { Messages } from '../../codegen/Localize';
import { WorkbookDefinition } from '../../ts/models/ContentDefinitions';
import { IWorkbookBase } from '../../ts/models/IWorkbookInfo';
import { Set } from '../../ts/models/Set';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { requestFailed } from '../../app/actions/RequestFailedAction';

import { SagaIterator } from 'redux-saga';
import { WorkbookAccelerationActions } from '../actions/WorkbookAccelerationActions';
import { EnableWorkbookAcceleration } from '../../app/actions/AppActionTypes';
import { EnableWorkbookAccelerationAction } from '../actions/EnableWorkbookAccelerationEntityAction';

export function openWorkbookAccelerationDialog(
  workbooks: Set<IWorkbookBase>,
  needsSchedule: boolean,
): ng.IPromise<IResult> {

  return WorkbookAccelerationActions.confirmEnableAcceleration(workbooks.toArray(), needsSchedule);
}

export function* handleEnableWorkbookAccelerationAction(action: EnableWorkbookAccelerationAction): SagaIterator {
  try {
    const contentDictionaryByType = _.groupBy(action.selectedContent, c => c.contentType);
    const typeArray = Object.keys(contentDictionaryByType);

    if (typeArray.length === 1) {
      const singleContentType = typeArray[0];
      switch (singleContentType) {
        case WorkbookDefinition.contentType:
          const needsSchedule = yield call(WorkbookAccelerationActions.accelerationNeedsSchedule, contentDictionaryByType[singleContentType]);
          const workbookSet = Set.fromIdItemArray(contentDictionaryByType[singleContentType]);
          try {
            yield call(openWorkbookAccelerationDialog, workbookSet, needsSchedule);
          } catch {
            // catches unresolved cancel promise - user presses Escape
            return;
          }
          break;
        default:
          yield put(requestFailed(`${singleContentType} does not support acceleration.`));
          break;
      }
    } else if (typeArray.length > 1) {
      // user selected multiple types of items while data acceleration only supports item type -- workbook
      yield put(requestFailed(`Acceleration only support workbooks.`, Messages.accelerationOnlySupportsWorkbooks()));
    }

  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function* rootEnableWorkbookAccelerationActionSaga(): SagaIterator {
  yield takeEvery(EnableWorkbookAcceleration, handleEnableWorkbookAccelerationAction);
}

